module.exports = __webpack_public_path__ + "assets/img/TimelineChecklist@2x.c6e69f38.png";